import { Route, Switch } from "react-router-dom";
// Liste des différentes pages de l'app
// Pages générales
import Home from "./Pages/Home";
import Connexion from "./Pages/Connexion";
import CreateUser from "./Pages/CreateUser";
import CreateUser2 from "./Pages/CreateUser2";
import NoMatch from "./Pages/NoMatch";
// Pages Sentier
import Sentier from "./Pages/path_sentier/Sentier";
import Balisage from "./Pages/path_sentier/balisage/Balisage";
import Securisation from "./Pages/path_sentier/securisation/Securisation";
import ChooseEtatTheme from "./Pages/path_sentier/etat/ChooseEtatTheme";
import Ferme from "./Pages/path_sentier/etat/ferme/Ferme";
import Difficultes from "./Pages/path_sentier/etat/difficultes/Difficultes";
import Signaletique from "./Pages/path_sentier/signaletique/Signaletique";
import ChooseTheme from "./Pages/ChooseTheme";
import Decouvrir from "./Pages/Decouvrir";
import Pourquoi from "./Pages/Pourquoi";
import PolitiqueConfidentialite from "./Pages/PolitiqueConfidentialite";
import PolitiqueCookie from "./Pages/PolitiqueCookie";
import Obstacles from "./Pages/path_sentier/etat/obstacles/Obstacles";
// Pages Services
import Services from "./Pages/path_services/Services";
import ServicesPublics from "./Pages/path_services/services_publics/ServicesPublics";
import Reseaux from "./Pages/path_services/services_publics/reseaux/Reseaux";
import WC from "./Pages/path_services/services_publics/wc/WC";
import Poubelles from "./Pages/path_services/services_publics/poubelles/Poubelles";
import Eau from "./Pages/path_services/services_publics/eau/Eau";
import Baignade from "./Pages/path_services/services_publics/baignade/Baignade";
import Hebergement from "./Pages/path_services/hebergement/Hebergement";
import Restauration from "./Pages/path_services/restauration/Restauration";
import Activites from "./Pages/path_services/activites/Activites";
import ServicesPro from "./Pages/path_services/services_pro/ServicesPro";
import Mobilite from "./Pages/path_services/mobilite/Mobilite";
import Stationnement from "./Pages/path_services/mobilite/stationnement/Stationnement";
import AiresCovoit from "./Pages/path_services/mobilite/aires_covoit/AiresCovoit";
import TransportsCommuns from "./Pages/path_services/mobilite/transports_communs/TransportsCommuns";
import Velo from "./Pages/path_services/mobilite/velo/Velo";
// Pages Frequentation
import Frequentation from "./Pages/path_frequentation/Frequentation";
import Gestion from "./Pages/path_frequentation/gestion/Gestion";
import EtatFrequentation from "./Pages/path_frequentation/etat/EtatFrequentation";
// Pages patrimoine
import Patrimoine from "./Pages/path_patrimoine/Patrimoine";
import Nature from "./Pages/path_patrimoine/nature/Nature";
import Bati from "./Pages/path_patrimoine/bati/Bati";
import Culture from "./Pages/path_patrimoine/culture/Culture";
import ObservationsNaturel from "./Pages/path_patrimoine/nature/observations/ObservationsNaturel";
import ObservationsBati from "./Pages/path_patrimoine/bati/observations/ObservationsBati";
import ObservationsCulture from "./Pages/path_patrimoine/culture/observations/ObservationsCulture";

import InformationsNaturel from "./Pages/path_patrimoine/nature/informations/InformationsNaturel";
import InformationsBati from "./Pages/path_patrimoine/bati/informations/InformationsBati";
import InformationsCulture from "./Pages/path_patrimoine/culture/informations/InformationsCulture";

import RisquesNature from "./Pages/path_patrimoine/nature/risques/RisquesNature";
import RisquesBati from "./Pages/path_patrimoine/bati/risques/RisquesBati";
import RisquesCulture from "./Pages/path_patrimoine/culture/risques/RisquesCulture";
import MentionsLegales from "./Pages/MentionsLegales";

const RouterIsthia = () => {
  return (
    <Switch>
      {/* Page racine */}
      <Route path="/" exact component={Home} />
      {/* Routes user */}
      <Route path="/user" exact component={Connexion} />
      <Route path="/create-user" exact component={CreateUser} />
      <Route path="/create-user-2" exact component={CreateUser2} />
      {/* Routes formulaire */}
      <Route path="/pourquoi" exact component={Pourquoi} />
      <Route path="/mentions-legales" exact component={MentionsLegales} />
      <Route path="/politique-cookies" exact component={PolitiqueCookie} />
      <Route
        path="/politique-confidentialite"
        exact
        component={PolitiqueConfidentialite}
      />
      <Route path="/decouvrir" exact component={Decouvrir} />
      <Route path="/observation" exact component={ChooseTheme} />
      {/* Routes sentier */}
      <Route path="/observation/sentier" exact component={Sentier} />
      <Route path="/observation/sentier/balisage" exact component={Balisage} />
      <Route
        path="/observation/sentier/securisation"
        exact
        component={Securisation}
      />
      <Route
        path="/observation/sentier/signaletique"
        exact
        component={Signaletique}
      />
      {/* Routes sentier -> etat */}
      <Route
        path="/observation/sentier/etat"
        exact
        component={ChooseEtatTheme}
      />
      <Route
        path="/observation/sentier/etat/obstacles"
        exact
        component={Obstacles}
      />
      <Route
        path="/observation/sentier/etat/difficultes"
        exact
        component={Difficultes}
      />
      <Route path="/observation/sentier/etat/ferme" exact component={Ferme} />
      {/* Routes services */}
      <Route path="/observation/services" exact component={Services} />
      <Route
        path="/observation/services/activites"
        exact
        component={Activites}
      />
      <Route
        path="/observation/services/hebergement"
        exact
        component={Hebergement}
      />
      <Route path="/observation/services/mobilite" exact component={Mobilite} />
      <Route
        path="/observation/services/services-pro"
        exact
        component={ServicesPro}
      />
      <Route
        path="/observation/services/restauration"
        exact
        component={Restauration}
      />
      <Route
        path="/observation/services/services-publics"
        exact
        component={ServicesPublics}
      />
      {/* Routes services -> mobilité */}
      <Route
        path="/observation/services/mobilite/aires-covoit"
        exact
        component={AiresCovoit}
      />
      <Route
        path="/observation/services/mobilite/stationnement"
        exact
        component={Stationnement}
      />
      <Route
        path="/observation/services/mobilite/velo"
        exact
        component={Velo}
      />
      <Route
        path="/observation/services/mobilite/transports-communs"
        exact
        component={TransportsCommuns}
      />
      {/* Routes services -> services publics */}
      <Route
        path="/observation/services/services-publics/reseaux"
        exact
        component={Reseaux}
      />
      <Route
        path="/observation/services/services-publics/wc"
        exact
        component={WC}
      />
      <Route
        path="/observation/services/services-publics/poubelles"
        exact
        component={Poubelles}
      />
      <Route
        path="/observation/services/services-publics/eau"
        exact
        component={Eau}
      />
      <Route
        path="/observation/services/services-publics/baignade"
        exact
        component={Baignade}
      />
      {/* Routes frequentation */}
      <Route
        path="/observation/frequentation"
        exact
        component={Frequentation}
      />
      <Route
        path="/observation/frequentation/etat"
        exact
        component={EtatFrequentation}
      />
      <Route
        path="/observation/frequentation/gestion"
        exact
        component={Gestion}
      />
      {/* Routes patrimoine */}
      <Route path="/observation/patrimoine" exact component={Patrimoine} />
      {/* Routes patrimoine -> architecture */}
      <Route
        path="/observation/patrimoine/architecture"
        exac
        component={Bati}
        t
      />
      <Route
        path="/observation/patrimoine/architecture/bati"
        exact
        component={Bati}
      />
      <Route
        path="/observation/patrimoine/architecture/informations"
        exact
        component={InformationsBati}
      />
      <Route
        path="/observation/patrimoine/architecture/risques"
        exact
        component={RisquesBati}
      />
      {/* Routes patrimoine -> culture */}
      <Route path="/observation/patrimoine/culture" exact component={Culture} />
      {/**
      
      <Route
        path="/observation/patrimoine/culture/immateriel"
        exact
        component={NoMatch}
      /> */}
      <Route
        path="/observation/patrimoine/culture/informations"
        exact
        component={InformationsCulture}
      />
      <Route
        path="/observation/patrimoine/culture/risques"
        exact
        component={RisquesCulture}
      />
      {/* Routes patrimoine -> nature */}
      <Route path="/observation/patrimoine/nature" exact component={Nature} />
      <Route
        path="/observation/patrimoine/nature/observations"
        exact
        component={ObservationsNaturel}
      />
      <Route
        path="/observation/patrimoine/nature/informations"
        exact
        component={InformationsNaturel}
      />
      <Route
        path="/observation/patrimoine/nature/risques"
        exact
        component={RisquesNature}
      />

      {/* Routes patrimoine -> bati */}
      <Route path="/observation/patrimoine/bati" exact component={Bati} />
      <Route
        path="/observation/patrimoine/bati/observations"
        exact
        component={ObservationsBati}
      />
      <Route
        path="/observation/patrimoine/bati/informations"
        exact
        component={InformationsBati}
      />
      <Route
        path="/observation/patrimoine/bati/risques"
        exact
        component={RisquesBati}
      />

      {/* Routes patrimoine -> culture */}
      <Route path="/observation/patrimoine/culture" exact component={Culture} />
      <Route
        path="/observation/patrimoine/culture/observations"
        exact
        component={ObservationsCulture}
      />
      <Route
        path="/observation/patrimoine/culture/informations"
        exact
        component={InformationsCulture}
      />
      <Route
        path="/observation/patrimoine/culture/risques"
        exact
        component={RisquesCulture}
      />
      {/* Page 404 */}
      <Route path="/" component={NoMatch} />
    </Switch>
  );
};

export default RouterIsthia;
